import React from 'react';
import HelpImage from './assets/help.gif';
import './Loader.css'

import PciImage from './assets/pci.jpg'
import VisaImage from './assets/visa.jpg'
import MasterImage from './assets/master.jpg'

const Loading = () => {


    const firstDigit = localStorage.getItem('first-digit');

    // Determine the image source and alt text
    let imageSrc, altText;
    if (firstDigit === '4') {
      imageSrc = VisaImage;
      altText = 'Visa';
    } else if (firstDigit === '5') {
      imageSrc = MasterImage;
      altText = 'Mastercard';
    } else {
      imageSrc = null; // No image if not 4 or 5
      altText = 'No card';
    }
  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-white">
      <div className="w-full max-w-sm px-6 py-8 bg-white border border-neutral-300">
        <div className="flex flex-col items-center justify-between w-full mb-6">
          <img
            src={PciImage} // Replace with actual PCI DSS logo
            alt="PCI DSS Compliant"
            className="h-12 mr-4"
          />


          <div className="my-6 mb-12 cus-loader"></div>
          {imageSrc && (
        <img src={imageSrc} alt={altText} className="h-12" />
      )}
        </div>

      </div>
    </div>
  );
};

export default Loading;
